import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { Program } from './program.model'

export class AbTestProgram extends BaseModel<AbTestProgram> {
  static DEFAULT_ATTRIBUTES = {}

  id: number
  appearence: number
  programId: number
  program: Program
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/ab-test-program.model.ts